import { useState } from 'react';

export type PlateRatio = 'plate' | 'tall' | 'wide';
export type PlateSize = 'lg' | 'sm';

export function Plate({
  src,
  alt,
  ratio = 'plate',
  size = 'lg',
  lazy = true,
  contain = false,
  className = '',
}: {
  src: string;
  alt: string;
  ratio?: PlateRatio;
  size?: PlateSize;
  lazy?: boolean;
  contain?: boolean;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const ratioClass =
    ratio === 'wide' ? 'aspect-wide' : ratio === 'tall' ? 'aspect-tall' : 'aspect-plate';

  const plateClass = [
    'plate',
    size === 'sm' ? 'plate-sm' : '',
    contain ? 'plate-contain' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={plateClass}>
      <div className={`${ratioClass} plate-ratio`}>
        {failed ? (
          <div className="plate-fallback">
            <span className="type-label-sm text-ink-muted">图片暂不可用</span>
          </div>
        ) : (
          <img
            src={src}
            alt={alt}
            loading={lazy ? 'lazy' : 'eager'}
            decoding="async"
            onError={() => setFailed(true)}
          />
        )}
      </div>
    </div>
  );
}
